import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { browserHistory, Link } from 'react-router';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import { Step, Stepper, StepButton } from 'material-ui/Stepper';
import Snackbar from 'material-ui/Snackbar';
import { copyPastPlanToPlan, createPlanAfter, createPlanItem, createInitialPlan, deletePlanItem, editPlanItem, getFacebookAdsForPlan, getPlanById, getPlanWithTimestamp, getAdsFocuses, hasPlan, setAdsFocusForPlan, applyAdsFocusToPlan, setUsePlanner, approveAdsPlan, setResultBoxStates } from 'redux/modules/adsPlanner';
import { getOrgPosts } from 'redux/modules/schedule';
import { AdDashboardCard, ButtonBar, CardRow, DataTable, EmptyState, ExpandableContainer, PageHeader, Spinner, InfoBox } from 'components';
import AdsPlanStep1 from './AdsPlanStep1';
import AdsPlanStep2 from './AdsPlanStep2';
import AdsPlanLeftCol from './AdsPlanLeftCol';
import * as styles from './AdsPlanner.scss';
import moment from 'moment';
import inflection from 'inflection';
import { populateComposebox } from 'redux/modules/composeboxForm';
var AdsPlanner = (_dec = connect(function (state, props) {
  var _state$schedule, _state$schedule$posts, _state$organization, _state$organization$s;

  var orgId = state.organization.current.id; // first filter for non-queued posts
  // then filter for posts that are FB

  var customPosts = state !== null && state !== void 0 && (_state$schedule = state.schedule) !== null && _state$schedule !== void 0 && (_state$schedule$posts = _state$schedule.posts) !== null && _state$schedule$posts !== void 0 && _state$schedule$posts[orgId] && !!state.schedule.posts[orgId].length ? state.schedule.posts[orgId].filter(function (p) {
    return !p.QueueId;
  }) : [];
  var fbCustomPosts = customPosts.filter(function (post) {
    return post === null || post === void 0 ? void 0 : post.SocialAccountPosts.some(function (sap) {
      return sap.SocialAccount && sap.SocialAccount.platform.includes('Facebook');
    });
  });
  return {
    organization: state.organization.current,
    isLikeableUser: state.config.userType.isLikeableUser,
    isPartnerUser: state.config.userType.isPartner,
    theme: state.theme,
    gettingPlan: state.adsPlanner && state.adsPlanner[orgId] ? state.adsPlanner[orgId].gettingPlan : true,
    currentPlanId: state.adsPlanner && state.adsPlanner[orgId] ? state.adsPlanner[orgId].currentPlanId : false,
    adsPlanner: state.adsPlanner && state.adsPlanner[orgId] ? state.adsPlanner[orgId] : null,
    usePlanner: state.adsPlanner && state.adsPlanner[orgId] ? state.adsPlanner[orgId].usePlanner : true,
    adsFocuses: state.adsPlanner && state.adsPlanner[orgId] ? state.adsPlanner[orgId].adsFocuses : [],
    customPosts: fbCustomPosts,
    gettingHasPlan: state.adsPlanner && state.adsPlanner[orgId] ? state.adsPlanner[orgId].gettingHasPlan : true,
    orgHasPlan: state.adsPlanner && state.adsPlanner[orgId] ? state.adsPlanner[orgId].hasPlan : false,
    orgDetails: (_state$organization = state.organization) !== null && _state$organization !== void 0 && (_state$organization$s = _state$organization.selectedOrgDetails) !== null && _state$organization$s !== void 0 && _state$organization$s[orgId] ? state.organization.selectedOrgDetails[orgId] : null,
    loadingFBAdsForPlan: state.adsPlanner && state.adsPlanner[orgId] ? state.adsPlanner[orgId].loadingFBAdsForPlan : false,
    adAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null,
    gettingAdsFocuses: state.adsPlanner && state.adsPlanner[orgId] ? state.adsPlanner[orgId].gettingAdsFocuses : false
  };
}, {
  applyAdsFocusToPlan: applyAdsFocusToPlan,
  approveAdsPlan: approveAdsPlan,
  copyPastPlanToPlan: copyPastPlanToPlan,
  createPlanAfter: createPlanAfter,
  createInitialPlan: createInitialPlan,
  createPlanItem: createPlanItem,
  deletePlanItem: deletePlanItem,
  editPlanItem: editPlanItem,
  getFacebookAdsForPlan: getFacebookAdsForPlan,
  getOrgPosts: getOrgPosts,
  getPlanById: getPlanById,
  getPlanWithTimestamp: getPlanWithTimestamp,
  getAdsFocuses: getAdsFocuses,
  hasPlan: hasPlan,
  populateComposebox: populateComposebox,
  setAdsFocusForPlan: setAdsFocusForPlan,
  setUsePlanner: setUsePlanner,
  setResultBoxStates: setResultBoxStates
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AdsPlanner, _Component);

  var _super = _createSuper(AdsPlanner);

  function AdsPlanner(props) {
    var _this;

    _classCallCheck(this, AdsPlanner);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "shouldFetchFacebookAdsInPlan", function (adsPlanId) {
      if (adsPlanId && _this.props.adAccount && _this.props.adAccount.adAccountId) {
        var fields = _this.props.adsPlanner && _this.props.adsPlanner.currentPlanId && _this.props.adsPlanner[_this.props.adsPlanner.currentPlanId] ? _this.props.adsPlanner[_this.props.adsPlanner.currentPlanId].resultStatTypes : [];

        _this.props.getFacebookAdsForPlan(_this.props.organization.id, adsPlanId, _this.props.adAccount.adAccountId, fields);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "loadAdsPlan", function (timestamp) {
      _this.props.getPlanWithTimestamp(_this.props.organization.id, timestamp).then(function (res) {
        if (res && res.data && res.data.adsPlan && res.data.adsPlan.isApproved) {
          _this.shouldFetchFacebookAdsInPlan(res.data.adsPlan.id);

          _this.props.setResultBoxStates(_this.props.organization.id, res.data.adsPlan.id, ['budget', 'spent', 'impressions', 'cost_per_action', 'days_left']);
        } // get posts for plan date range


        _this.props.getOrgPosts(_this.props.organization.id, _this.props.orgDetails.OrganizationTimezone, res.data.adsPlan.dateStart, res.data.adsPlan.dateEnd);
      })["catch"](function (e) {
        console.error(e);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "formatCurrency", function (amount) {
      var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var amountInDollars = cents ? amount / 100.0 : amount;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(amountInDollars);
    });

    _defineProperty(_assertThisInitialized(_this), "formatData", function (ads) {
      return ads.sort(function (a, b) {
        return moment(b.campaign.stop_time).format('YYYYMMDD') - moment(a.campaign.stop_time).format('YYYYMMDD');
      }).map(function (a) {
        if (a) {
          var hasFBInsights = a.insights && a.insights.facebook;
          var imgUrl = a.creative && a.creative.thumbnail_url ? a.creative.thumbnail_url : 'https://s3.amazonaws.com/likeabucket/user_upload/22/YAeZfa747.png';
          var dates = /*#__PURE__*/React.createElement("div", {
            style: {
              fontSize: 14,
              width: 200
            }
          }, moment(a.campaign.start_time).format('MM/DD/YYYY'), " - ", moment(a.campaign.stop_time).format('MM/DD/YYYY'));
          return {
            id: a.id,
            name: a.name ? /*#__PURE__*/React.createElement("div", {
              style: {
                display: 'flex',
                alignItems: 'flex-start',
                maxWidth: 275,
                minWidth: 225
              }
            }, /*#__PURE__*/React.createElement("img", {
              src: imgUrl,
              style: {
                height: 50,
                marginRight: 8
              }
            }), /*#__PURE__*/React.createElement("div", null, _.startsWith(a.name, 'act_') ? _this.formatTableText('Promoted Post') : _this.formatTableText(a.name))) : '',
            objective: /*#__PURE__*/React.createElement("div", {
              style: {
                minWidth: 150,
                fontSize: 14
              }
            }, _.startCase(a.campaign.objective.toLowerCase())),
            dates: dates,
            cpc: hasFBInsights && a.insights.facebook.cpc ? _this.formatTableText("$".concat(a.insights.facebook.cpc.toFixed(2))) : _this.formatTableText('-'),
            spend: hasFBInsights && a.insights.facebook.spend ? _this.formatTableText("$".concat(a.insights.facebook.spend.toFixed(2))) : _this.formatTableText('-'),
            impressions: hasFBInsights && a.insights.facebook.impressions ? _this.formatTableText(a.insights.facebook.impressions) : _this.formatTableText('-'),
            reach: hasFBInsights && a.insights.facebook.reach ? _this.formatTableText(a.insights.facebook.reach) : _this.formatTableText('-')
          };
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "formatTableText", function (text) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 14
        }
      }, text);
    });

    _defineProperty(_assertThisInitialized(_this), "handleTabChanged", function (tab) {
      var tabCopy = [].concat(_this.state.tabs);
      tabCopy.forEach(function (t) {
        t.selected = t.key === tab.key;
      });

      _this.setState({
        tabs: tabCopy,
        selectedTab: tab.key
      }, function () {
        if (tab.key === 'build') {
          _this.loadAdsPlan(_this.state.currentPlanTimestamp);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleNewAdBtnClick", function (categoryId) {
      _this.props.createPlanItem(_this.props.organization.id, categoryId);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDeletePlanItem", function (itemId) {
      _this.props.deletePlanItem(_this.props.organization.id, itemId);
    });

    _defineProperty(_assertThisInitialized(_this), "handleEditPlanItem", function (itemId, itemName, itemBudget) {
      _this.props.editPlanItem(_this.props.organization.id, itemId, {
        name: itemName,
        budgetInCents: parseFloat(itemBudget) * 100
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCopyPreviousMonth", function (targetPlan, previousPlan) {
      _this.props.copyPastPlanToPlan(_this.props.organization.id, previousPlan.id, targetPlan.id);
    });

    _defineProperty(_assertThisInitialized(_this), "handleApproveAdsPlan", function (planId) {
      _this.props.approveAdsPlan(_this.props.organization.id, planId).then(function () {
        _this.props.createPlanAfter(_this.props.organization.id, planId);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnBuildBoostAd", function (plan, category, ad) {
      _this.props.populateComposebox({}, _this.props.organization.id, {
        fromPlannedAd: ad,
        fromPlannedAdCategory: category,
        minDate: moment(plan.dateStart).isBefore(moment()) ? moment().add(12, 'hours').toDate() : moment(plan.dateStart).add(12, 'hours').toDate(),
        maxDate: moment(plan.dateEnd).toDate()
      });

      _this.props.router.push("/org/".concat(_this.props.organization.id, "/compose"));
    });

    _defineProperty(_assertThisInitialized(_this), "renderMonthNav", function (adsPlan, paging) {
      var startDate = moment(adsPlan.dateStart).format('M/D/YY');
      var endDate = moment(adsPlan.dateEnd).format('M/D/YY');
      var nextMonth = moment(adsPlan.dateEnd).add(1, 'day');
      var prevMonth = moment(adsPlan.dateStart).subtract(1, 'day');
      var monthName = "".concat(startDate, " - ").concat(endDate);
      return /*#__PURE__*/React.createElement("div", {
        className: styles.monthNavWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.monthNavInnerWrap
      }, paging && paging.before && /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-arrow-back ".concat(styles.monthNavPrevBtn),
        onClick: function onClick() {
          _this.setState({
            currentPlanTimestamp: prevMonth.valueOf()
          });

          _this.loadAdsPlan(prevMonth.valueOf());
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.monthNavName
      }, monthName), paging && paging.after && /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-arrow-forward ".concat(styles.monthNavNextBtn),
        onClick: function onClick() {
          _this.setState({
            currentPlanTimestamp: nextMonth.valueOf()
          });

          _this.loadAdsPlan(nextMonth.valueOf());
        }
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderDataTable", function (planAds) {
      var adsData = _this.formatData(planAds.ads);

      var headerFields = [{
        name: 'Name',
        key: 'name'
      }, {
        name: 'Objective',
        key: 'objective'
      }, {
        name: 'Dates',
        key: 'dates'
      }, {
        name: 'Impressions',
        key: 'impressions'
      }, {
        name: 'Reach',
        key: 'reach'
      }, {
        name: 'Spend',
        key: 'spend'
      }, {
        name: 'CPC',
        key: 'cpc'
      }];
      return /*#__PURE__*/React.createElement("div", {
        style: {
          margin: '0 36px 36px'
        }
      }, /*#__PURE__*/React.createElement(DataTable, {
        noRowClasses: true,
        headerFields: headerFields,
        displaySearch: false,
        onRowSelection: function onRowSelection(data) {
          _this.setState({
            clickedAdId: data.id
          }, function () {
            /*
                  // load image before showing Dialog, so height is correct
                  const image = new Image();
                  image.src = data.rawData.full_picture;
                  image.onload = () => {
                    this.setState({ showRowDetailModal: true });
                  };
                  */
          });
        },
        data: adsData,
        loading: _this.props.loadingAllAds,
        style: {
          width: '100%'
        },
        hideSort: true
      }));
    });

    _this.state = {
      currentPlanTimestamp: Date.now(),
      snackbarMessage: '',
      snackbarOpen: false,
      selectedTab: 'build',
      tabs: [{
        title: 'Plan',
        key: 'plan'
      }, {
        title: 'Build',
        key: 'build',
        selected: true
      }]
    };
    return _this;
  }
  /** *********************************************************
   LIFECYCLE METHODS
   ***********************************************************/


  _createClass(AdsPlanner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      /* this.props.hasPlan(this.props.organization.id).then(res => {
        if (res.data.hasPlans) {
          this.loadAdsPlan(Date.now());
        }
      });*/
      this.loadAdsPlan(this.state.currentPlanTimestamp);
      this.props.getAdsFocuses(this.props.organization.id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          adsPlanner = _this$props.adsPlanner,
          currentPlanId = _this$props.currentPlanId,
          customPosts = _this$props.customPosts;
      var orgId = this.props.organization.id;
      var adsPlan = this.props.adsPlanner && this.props.adsPlanner[this.props.currentPlanId] ? this.props.adsPlanner[this.props.currentPlanId] : false;
      var pastMonth = adsPlan ? moment(adsPlan.dateEnd).isBefore(moment()) : false;
      var paging = !this.props.gettingPlan ? this.props.adsPlanner.paging : false;
      var plannedAdsTotal = adsPlan && adsPlan.AdsPlannerCategories ? adsPlan.AdsPlannerCategories.reduce(function (accumulator, cat) {
        return accumulator + parseInt(cat.budget);
      }, 0) : 0;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Helmet, {
        title: "Advertising - Ads Planner"
      }), /*#__PURE__*/React.createElement("div", {
        className: "container-fluid"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          padding: '0 36px'
        }
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Advertising",
        secondary: "Ads Planner",
        pageTitleStyle: {
          marginTop: 0
        }
      })), /*#__PURE__*/React.createElement("div", null, adsPlan && /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, this.renderMonthNav(adsPlan, paging), (this.props.isLikeableUser || this.props.isPartnerUser) && /*#__PURE__*/React.createElement("div", {
        className: styles.tabWrap
      }, /*#__PURE__*/React.createElement(ButtonBar, {
        "class": false,
        items: this.state.tabs,
        onChange: this.handleTabChanged,
        style: {
          marginBottom: 16,
          marginLeft: 24
        }
      }), this.state.selectedTab === 'plan' && paging && paging.before && /*#__PURE__*/React.createElement(RaisedButton, {
        style: {
          marginLeft: 36
        },
        label: "Copy Previous Plan",
        onClick: function onClick() {
          if (confirm('Copying your previous plan will overwrite your current plan. Continue?') == true) {
            _this2.handleCopyPreviousMonth(adsPlan, paging.before);
          }
        }
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.plannerWrap
      }, plannedAdsTotal > 0 && /*#__PURE__*/React.createElement("div", {
        className: styles.leftCol
      }, /*#__PURE__*/React.createElement(AdsPlanLeftCol, {
        adsPlan: adsPlan,
        formatCurrency: this.formatCurrency,
        adsFocuses: this.props.adsFocuses
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.rightCol
      }, /*#__PURE__*/React.createElement("div", null, this.state.selectedTab === 'plan' && (this.props.isLikeableUser || this.props.isPartnerUser) ? /*#__PURE__*/React.createElement(AdsPlanStep1, {
        adsPlan: adsPlan,
        formatCurrency: this.formatCurrency,
        handleEditPlanItem: this.handleEditPlanItem,
        handleDeletePlanItem: this.handleDeletePlanItem,
        handleNewAdBtnClick: this.handleNewAdBtnClick,
        handleApproveAdsPlan: this.handleApproveAdsPlan,
        pastMonth: pastMonth
      }) : /*#__PURE__*/React.createElement(AdsPlanStep2, {
        onBuildAd: this.handleOnBuildBoostAd,
        adsPlan: adsPlan,
        formatCurrency: this.formatCurrency,
        customPosts: customPosts,
        pastMonth: pastMonth
      })))), this.state.selectedTab === 'build' && adsPlan && adsPlan.results && !adsPlan.loadingFacebookHistory && (adsPlan.isActive || pastMonth) && plannedAdsTotal > 0 && /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: 24,
          marginRight: 24
        }
      }, /*#__PURE__*/React.createElement(ExpandableContainer, {
        style: {
          marginTop: 40
        },
        height: 'auto',
        title: 'Results'
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-around'
        }
      }, Object.keys(adsPlan.results).filter(function (k) {
        return k.indexOf('_display') === -1;
      }).map(function (key, index) {
        return /*#__PURE__*/React.createElement(InfoBox, {
          key: index,
          title: inflection.titleize(key.replace(/_/g, ' ')),
          info: adsPlan.results["".concat(key, "_display")]
        });
      }))))), this.state.selectedTab === 'build' && adsPlan && /*#__PURE__*/React.createElement("div", null, adsPlan && adsPlan.planAds && adsPlan.planAds.ads && !!adsPlan.planAds.ads.length && !this.props.loadingFBAdsForPlan ? this.renderDataTable(adsPlan.planAds) : this.props.loadingFBAdsForPlan ? [/*#__PURE__*/React.createElement("div", {
        className: "row",
        key: "title"
      }, /*#__PURE__*/React.createElement("h4", {
        className: styles.plannerAdsHeader
      }, "Ads In Plan")), /*#__PURE__*/React.createElement("div", {
        key: "spinner",
        style: {
          position: 'relative',
          height: 75,
          marginTop: 50
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }))] : plannedAdsTotal > 0 ? /*#__PURE__*/React.createElement(EmptyState, {
        text: "No ads in this plan yet.",
        iconName: "ion-android-expand",
        iconSize: "95px",
        style: {
          marginBottom: 50,
          marginTop: 50
        }
      }) : /*#__PURE__*/React.createElement(EmptyState, {
        text: "No ads have been planned.",
        iconName: "ion-android-expand",
        iconSize: "95px",
        style: {
          marginBottom: 50,
          marginTop: 50
        },
        buttonLabel: this.props.isLikeableUser || this.props.isPartnerUser ? 'Plan some now' : null,
        buttonOnClick: function buttonOnClick() {
          var tabCopy = [].concat(_this2.state.tabs);
          tabCopy.forEach(function (t) {
            t.selected = t.key === 'plan';
          });

          _this2.setState({
            tabs: tabCopy,
            selectedTab: 'plan'
          });
        }
      })), /*#__PURE__*/React.createElement(Snackbar, {
        open: this.state.snackbarOpen,
        message: this.state.snackbarMessage,
        autoHideDuration: 4000,
        onRequestClose: function onRequestClose() {
          _this2.setState({
            snackbarOpen: false
          });
        }
      })), !adsPlan && (this.props.gettingHasPlan || this.props.gettingPlan) && /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 75,
          marginTop: 50
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })), !this.props.gettingHasPlan && !this.props.gettingPlan && this.props.orgHasPlan && !adsPlan && /*#__PURE__*/React.createElement(EmptyState, {
        text: "Your current ad plan isn't ready yet. Check back soon!",
        iconName: "ion-map",
        iconSize: "95px"
      }))));
    }
  }]);

  return AdsPlanner;
}(Component)) || _class);
export { AdsPlanner as default };